var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import useLogo from '../../helpers/hooks/useLogo';
const HeaderLogo = () => {
    _react_refresh_temp_2();
    const logo = useLogo();
    return (_jsx("div", { className: "header-logo", children: _jsx("img", { className: "header-logo-img", src: `${logo}`, alt: "logo" }) }));
};
_react_refresh_temp_1 = HeaderLogo;
$RefreshReg$(_react_refresh_temp_1, "HeaderLogo");
_react_refresh_temp_2(HeaderLogo, "YgIq2xNtRL4gwdBSBNon6XMW2hw=", false, () => [useLogo]);
export default HeaderLogo;
